import { legalConfig as cfg } from '../legalConfig';
import { LegalDoc } from '../types';

export const cookiesDoc: LegalDoc = {
  slug: 'cookies',
  title: 'Cookie Notice',
  effectiveDate: cfg.effectiveDate,
  lastUpdated: cfg.lastUpdated,
  intro: [
    `${cfg.brandName} uses essential technologies to keep the service secure and working. With your permission, we may also use optional analytics to understand and improve ${cfg.brandName}. You can change your choice at any time using the "Cookie settings" link in the footer.`,
  ],
  sections: [
    {
      heading: 'Cookie categories',
      blocks: [
        {
          type: 'ul',
          items: [
            'Essential: authentication, security, fraud prevention, preferences, and core functions. These cannot be switched off where required to provide the service.',
            `Analytics: helps ${cfg.brandName} understand feature use, errors, and performance. Used only with your consent.`,
            'Advertising: not currently used. This notice will be updated with a separate privacy and consent review before any advertising technology is introduced.',
          ],
        },
      ],
    },
    {
      heading: 'Managing your choice',
      blocks: [
        {
          type: 'p',
          text: 'You can accept or reject optional cookies from the cookie banner, and revisit that choice anytime via "Cookie settings" in the footer. Rejecting optional cookies does not affect essential functions.',
        },
        {
          type: 'note',
          text: 'Before publication, maintain a cookie table listing the actual cookie or SDK name, provider, purpose, information collected, duration, and whether information is transferred outside South Africa.',
        },
      ],
    },
  ],
};
